import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type UploadFileWithPreviewFormDataFragment = (
  { __typename: 'UploadedFileWithPreview' }
  & Pick<SchemaTypes.UploadedFileWithPreview, 'id' | 'filename' | 'url'>
  & { preview?: SchemaTypes.Maybe<(
    { __typename: 'UploadedFile' }
    & Pick<SchemaTypes.UploadedFile, 'id' | 'url'>
  )> }
);

export const UploadFileWithPreviewFormDataFragmentDoc = /*#__PURE__*/ gql`
    fragment UploadFileWithPreviewFormData on UploadedFileWithPreview {
  id
  filename
  url
  preview {
    id
    url
  }
}
    `;